import { TmApiClientError } from '@/core/error/transport/tmApiClientError'
import type { TmTransportHttpErrorCode } from '@/core/error/transport/types'

export class TmApiLockedError extends TmApiClientError {
  public name = 'TmApiLockedError'

  protected override code: TmTransportHttpErrorCode = 423
}
